<template>
  <multiselect
    v-bind="$attrs"
    v-model="selectedValue"
    v-bind:options="options"
    selectedLabel=""
    selectLabel=""
    deselectLabel=""
    selectGroupLabel=""
    deselectGroupLabel=""
  >
    <template class="w-100" v-slot:option="option">
      <slot class="w-100" name="option" v-bind:option="option"></slot>
    </template>
    <template class="w-100" v-slot:noResult="option">
      <slot class="w-100" name="noFoundResult" v-bind:noResult="option">
        <span>
          {{ "Nenhum resultado encontrado" }}
        </span>
      </slot>
    </template>
    <template class="w-100" v-slot:noOptions="option">
      <slot class="w-100" name="noOptions" v-bind:noOptions="option">
        <span>
          {{ "Nenhuma opção disponível" }}
        </span>
      </slot>
    </template>
  </multiselect>
</template>

<script>
export default {
  name: "NeoSelect",
  inheritAttrs: false,
  props: {
    value: {
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedValue: this.value,
    };
  },
  watch: {
    selectedValue(newValue) {
      this.$emit("update:value", newValue);
    },
  },
  methods: {
    clear() {
      this.selectedValue = null;
    },
    selectOption(value, label = "id") {
      this.selectedValue = this.options.find(
        (option) => option[label] === value
      );
    },
  },
};
</script>

<style lang="scss">
.multiselect__option--selected {
  background: #b2b3b3 !important;
  &:hover {
    background: #ff6a6a !important;
  }
}


</style>
